// extracted by mini-css-extract-plugin
export default {"inputContainer":"Search_inputContainer__e-8C7","searchIcon":"Search_searchIcon__Qx1Yn","searchInput":"Search_searchInput__FHeUB"};